const GENERATIONAL_SUFFIX = /[\s,]+((?:jr|sr|ii|iii|iv|v)\.?)$/i;

export function formatBillingHistoryPerformedBy(performedByName: string): string {
    const trimmed = performedByName.trim();
    const suffixMatch = GENERATIONAL_SUFFIX.exec(trimmed);
    const withoutSuffix = trimmed.replace(GENERATIONAL_SUFFIX, '');
    const hasSurnameBeforeSuffix = suffixMatch !== null && /\s/.test(withoutSuffix);
    const name = hasSurnameBeforeSuffix ? withoutSuffix : trimmed;
    const suffix = hasSurnameBeforeSuffix ? ` ${suffixMatch[1]}` : '';
    const words = name.split(/\s+/).filter(Boolean);
    const first = words[0];
    const last = words[words.length - 1];

    if (first === undefined || last === undefined) {
        return '';
    }

    return words.length === 1 ? first : `${first.charAt(0)}. ${last}${suffix}`;
}
